module.exports = __webpack_public_path__ + "img/socialSecurity.fb974bca.png";